var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppCompletion(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6812_34412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.84349 19.7573C6.84349 20.878 5.7503 21.1166 5.43351 21.1626C4.69281 21.1419 4.09677 20.521 4.09677 19.7573V2.37876H12.3369V0.5H3.1812C2.6758 0.5 2.26562 0.920842 2.26562 1.43938V19.7573C2.26562 21.5703 3.70307 23.0451 5.47013 23.0451H19.2037C20.9708 23.0451 22.4082 21.5703 22.4082 19.7573V18.3482H6.84349V19.7573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8342 11.7726C16.4727 11.7726 15.2111 11.3311 14.1719 10.5852V16.4695L17.8342 13.6513L21.4965 16.4695V10.5852C20.4573 11.3311 19.1956 11.7726 17.8342 11.7726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8357 9.89379C20.364 9.89379 22.4135 7.79092 22.4135 5.1969C22.4135 2.60287 20.364 0.5 17.8357 0.5C15.3074 0.5 13.2578 2.60287 13.2578 5.1969C13.2578 7.79092 15.3074 9.89379 17.8357 9.89379Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6812_34412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.9737,
    height: 22.5451,
    fill: "white",
    transform: "translate(0.4375 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppCompletion);
export default __webpack_public_path__ + "static/media/app-completion.1d5cf6de8da3231ee1b7eb385e473a64.svg";
export { ForwardRef as ReactComponent };